import styled from 'styled-components';

import Affix from '@components/Affix/next';

export const ResponsiveBox = styled.div`
  width: 100%;
  padding: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  border-radius: 8px;
`;

export const ResponsiveBoxContainer = styled.div`
  width: 100%;
  padding: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  position: relative;
  border-radius: 8px;
`;

export const ResponsiveBoxAffix = styled(Affix)<{ sticky?: boolean }>`
  position: ${({ sticky }) => (sticky ? 'fixed' : 'static')} !important;
`;

export const ResponsiveSearchBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ResponsiveSearchBoxEdit = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const ResponsiveSearchBoxEditLabel = styled.div`
  text-decoration-line: underline;
  text-wrap: nowrap;
  color: ${({ theme }) => theme.palette.B300};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SearchIconWrapper = styled.div`
  margin-top: 5px;
`;
